module.exports = __webpack_public_path__ + "static/WeinTour_TV_Web-1-scaled-286e787249e6cfe0266aed676011a50b.jpeg";